/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/content-ai-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/content-ai-api-client";
import type { ContentGetByKeyQueryResponse, ContentGetByKeyPathParams } from "../models/ContentGetByKey";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { contentGetByKey } from "../axios/contentGetByKey";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const contentGetByKeyQueryKey = (key: ContentGetByKeyPathParams["key"]) => ["content-ai-api", { url: '/contents/key/:key', params: {key:key} }] as const

export type ContentGetByKeyQueryKey = ReturnType<typeof contentGetByKeyQueryKey>

export function contentGetByKeyQueryOptions(key: ContentGetByKeyPathParams["key"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = contentGetByKeyQueryKey(key)
  return queryOptions<ContentGetByKeyQueryResponse, ResponseErrorConfig<Error>, ContentGetByKeyQueryResponse, typeof queryKey>({
   enabled: !!(key),
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return contentGetByKey(key, config)
   },
  })
}

/**
 * @description Keys are used to identify fragments based on an external ID (e.g.: `FRAGMENT:123456`)
 * @summary Get content by key
 * {@link /contents/key/:key}
 */
export function useContentGetByKey<TData = ContentGetByKeyQueryResponse, TQueryData = ContentGetByKeyQueryResponse, TQueryKey extends QueryKey = ContentGetByKeyQueryKey>(key: ContentGetByKeyPathParams["key"], options: 
{
  query?: Partial<QueryObserverOptions<ContentGetByKeyQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? contentGetByKeyQueryKey(key)

  const query = useQuery({
   ...contentGetByKeyQueryOptions(key, config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}